import { ArrowLeft, ArrowRight, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { STEPS } from "@/lib/boyCourier";
import { cn } from "@/lib/utils";

export function StepBar({ step, onBack }) {
  return (
    <div className="space-y-2.5" data-testid="boy-signup-progress">
      <div className="flex items-center justify-between gap-3 text-xs">
        {step > 0 ? (
          <button type="button" onClick={onBack} className="inline-flex items-center gap-1 font-semibold text-muted-foreground transition-colors hover:text-foreground" data-testid="boy-signup-back">
            <ArrowLeft className="h-4 w-4" />Voltar
          </button>
        ) : <span />}
        <span className="font-mono font-semibold uppercase tracking-wider text-muted-foreground" data-testid="boy-signup-step-label">Etapa {step + 1} de {STEPS.length} · {STEPS[step]}</span>
      </div>
      <div className="grid grid-cols-5 gap-1.5">
        {STEPS.map((s, i) => (
          <span key={s} className={cn("h-2 rounded-full transition-colors duration-500", i <= step ? "bg-primary" : "bg-muted")} data-testid={`boy-signup-progress-${i}`} />
        ))}
      </div>
    </div>
  );
}

export function StepHead({ title, text }) {
  return (
    <div className="space-y-1.5">
      <h1 className="text-2xl font-bold leading-tight" data-testid="boy-step-title">{title}</h1>
      {text && <p className="text-sm text-muted-foreground" data-testid="boy-step-subtitle">{text}</p>}
    </div>
  );
}

export function NextBtn({ busy, disabled, testid, children }) {
  return (
    <Button type="submit" className="h-12 w-full text-base" disabled={busy || disabled} data-testid={testid}>
      {busy && <Loader2 className="mr-2 h-5 w-5 animate-spin" />}{children}{!busy && <ArrowRight className="ml-2 h-5 w-5" />}
    </Button>
  );
}
